// Recovered compiled webpack factory 33855. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { X: () => s });
  let n = (t) => null !== t;
  function s(t, { repeat: e, repeatType: i = "loop" }, r, o = 1) {
    let a = t.filter(n),
      l = o < 0 || (e && "loop" !== i && e % 2 == 1) ? 0 : a.length - 1;
    return l && void 0 !== r ? r : a[l];
  }
}
